import { render, staticRenderFns } from "./PickupCalendarPage.vue?vue&type=template&id=37c17d52"
import script from "./PickupCalendarPage.vue?vue&type=script&lang=ts"
export * from "./PickupCalendarPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports